import React, { useEffect, useCallback } from 'react';
import styles from './RightPanel.module.scss';
import Home from './Home/Home';
import About from './About/About';
import Resume from './Resume/Resume';
import Contact from './Contact/Contact';

const sections = ['home', 'about', 'resume', 'contact'];

// eslint-disable-next-line react/prop-types
function RightPanel({ setActiveTab }) {

  const handleScrollEvent = useCallback(() => {
    let activeSection = 'home'; // Default to 'home'

    sections.forEach((section) => {
      const element = document.getElementById(section);
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
          activeSection = section;
        }
      }
    });

    setActiveTab(activeSection);
    window.history.replaceState(null, null, `#${activeSection}`);
  }, [setActiveTab]);

  // Add scroll listener on mount and clean up on unmount
  useEffect(() => {
    const scrollContainer = document.getElementById('scrollable-container');

    // Check the URL hash when the component mounts
    const initialTab = window.location.hash.substring(1); // Remove '#' from hash
    if (initialTab && sections.includes(initialTab)) {
      setActiveTab(initialTab); // Set the active tab based on the URL hash
      const element = document.getElementById(initialTab);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' }); // Smooth scroll to the element
      }
    }

    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScrollEvent);
    }

    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', handleScrollEvent);
      }
    };
  }, [setActiveTab, handleScrollEvent]);

  return (
    <div className={styles.rightPanelContainer} id="scrollable-container">
      <section className={styles.contentLayer}>
        <Home setActiveTab={setActiveTab} />
      </section>
      <section className={styles.aboutContent}>
        <About />
      </section>
      <section>
        <Resume />
      </section>
      <section>
        <Contact />
      </section>
    </div>
  );
}

export default RightPanel;
